import { z } from "zod";
import { CorrelationIdSchema, TraceIdSchema } from "../primitives/ids.js";
/** Observe-only conversion events — must not drive product truth. */
export const PrivacyClassSchema = z.enum([
    "PUBLIC_MARKETING",
    "AGENCY_OPERATOR",
    "INTERNAL_OPS",
]);
export const RetentionClassSchema = z.enum([
    "EPHEMERAL_SESSION",
    "DAYS_90",
    "DAYS_365",
]);
export const ConversionEventTypeSchema = z.enum([
    "PAGE_VIEW",
    "SUBMIT",
    "CLAIM",
    "PAID",
    "CERTIFICATE_VIEW",
]);
export const ConversionEventIdSchema = z
    .string()
    .regex(/^cevt_[a-zA-Z0-9_-]+$/)
    .brand();
export const ConversionEventCaptureRequestV1Schema = z
    .object({
    schemaVersion: z.literal("conversion-event-capture.v1.0"),
    eventType: ConversionEventTypeSchema,
    privacyClass: PrivacyClassSchema,
    retentionClass: RetentionClassSchema,
    occurredAt: z.string().datetime().optional(),
    pagePath: z.string().max(512).optional(),
    utmSource: z.string().max(128).optional(),
    utmMedium: z.string().max(128).optional(),
    utmCampaign: z.string().max(128).optional(),
    sessionKey: z.string().max(128).optional(),
    traceId: TraceIdSchema.optional(),
    correlationId: CorrelationIdSchema.optional(),
    /** Non-PII metadata only — no emails, names, or payment identifiers. */
    metadata: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])).optional(),
})
    .strict()
    .superRefine((value, ctx) => {
    if (!value.privacyClass) {
        ctx.addIssue({ code: "custom", message: "privacyClass is required", path: ["privacyClass"] });
    }
    if (!value.retentionClass) {
        ctx.addIssue({ code: "custom", message: "retentionClass is required", path: ["retentionClass"] });
    }
});
export const ConversionEventAcceptedV1Schema = z
    .object({
    schemaVersion: z.literal("conversion-event-accepted.v1.0"),
    eventId: ConversionEventIdSchema,
    acceptedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=conversion-tracking.js.map